import React from 'react';
import styles from './MaintenancePage.module.css';
import maintenanceIcon from '../assets/images/site-maintenance.svg';
import useTranslation from '../components/contexts/LanguageTranslation/useTranslation';

const MaintenancePage = () => {
    const international = useTranslation('components/shared/MaintenancePage/MaintenancePage');
    const { translations } = international;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img
                    src={maintenanceIcon}
                    alt='Site Maintenance in Progress'
                    className={styles.icon}
                />
                <h2>{translations?.p1Maintenance || 'SITE MAINTENANCE \nIN PROGRESS.'}</h2>
            </div>

            <h3 className={styles.message}>
                {translations?.p2Maintenance || 'Thanks for your patience - please check back shortly.'}
            </h3>
        </div>
    );
};

export { MaintenancePage };
